import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomTable,
    RaikoGridOneColumn, RaikoTableTitleContainer, showErrorMessage,
    convertUniversalDateToPersianDate, RaikoDefaultDialogPage, DialogSize, addNewRowToTable
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {useNavigate} from "react-router-dom";
import {EtekafService} from "../../serverService/etekafService/EtekafService";
import EtekafManagerAddNewList from "./EtekafManagerAddNewList";



export default function EtekafManagerList() {

    let page = 0
    const size = 15

    const navigate = useNavigate()

    const service = new EtekafService()

    useEffect(() => {
        if (service) {
            getDataFromServer()
        }
    }, [])

    const [etekafList, setEtekafList] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoadingState, setTableLoadingState] = useState(false);
    const [totalItems, setTotalItems] = useState(0);

    function getDataFromServer() {

        setTableLoadingState(true)

        service.getEtekafListData(page, size)
            .then(response => {
                                setPageCount(response.totalPage)
                                setTotalItems(response.numberOfItems)

                                setEtekafList([])

                                response.data.map((item, index) => {
                                    setEtekafList(prevState => [
                                        ...prevState,
                                        createEtekafTableRow(
                                            item.id,
                                            (page * size) + index + 1,
                                            item.title,
                                            item.createdAt,
                                            item.createdBy,
                                            item.startDate,
                                            item.endDate
                                        )
                                    ])
                                })

                                setTableLoadingState(false)
                            }).catch(reason => {
                            showErrorMessage(reason)
                            setTableLoadingState(false)
                        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function handleShowResidenceDetail(itemId) {
        let _title = ""
        etekafList.map((item) => {
            if (item.id === itemId)
                _title = item.name
        })
        navigate(RouteHelper.EtekafDetails.globalUrl.replace(":id", itemId),
            {state: {title: _title}, replace: false}
        )
    }


    const [openDialogState, setOpenDialogState] = useState(false)
    const handleOpenDialog = () => setOpenDialogState(true)
    const handleCloseDialog = () => setOpenDialogState(false)


    function addNewPlaceToTable(item) {
        let rowToTable = addNewRowToTable(
            createEtekafTableRow(
                item.id,
                item.title,
                item.createdAt,
                item.createdBy,
                item.startDate,
                item.endDate
            ),
            etekafList
        );

        setEtekafList(rowToTable);
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.EtekafManagerList.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialogState}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <EtekafManagerAddNewList
                    handleCloseDialog={handleCloseDialog}
                    handleAddNewPlace={addNewPlaceToTable}

                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "اعتکاف",
                                RouteHelper.EtekafManagerList.url
                            ),
                            raikoBreadCrumbItemGenerator(
                                "لیست دوره های اعتکاف",
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={RouteHelper.EtekafManagerList.name}
                                hasCreateNewItem
                                handleCreateNewItem={handleOpenDialog}
                                amount={totalItems}
                            />
                            <RaikoCustomTable
                                data={etekafList}
                                header={etekafTableHeader}
                                isLoading={tableLoadingState}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePagination}
                                rowClicked={handleShowResidenceDetail}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

function createEtekafTableRow(
    id,
    number,
    name,
    createdAt,
    createdBy,
    startDate,
    endDate
) {
    return {
        id,
        number,
        name,
        createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
        createdBy,
        startDate: convertUniversalDateToPersianDate(startDate),
        endDate: convertUniversalDateToPersianDate(endDate),
    }
}


const etekafTableHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "name",
        label: "نام",
    },
    {
        id: "startDate",
        label: "تاریخ شروع",
    },
    {
        id: "endDate",
        label: "تاریخ پایان",
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت",
    },
    {
        id: "createdBy",
        label: "سازنده",
    },

]
